<div style="position:relative;">
  <button nbButton status="info"
          ghost
          (click)="openSearch(info,
          getContext(), true)"
          [disabled]="checkDisable()"
          aria-label="Manage links">
    <nb-badge
      class="large"
      position="top left"
      status="danger"
      *ngIf="linkCount() == 0" text="!">
    </nb-badge>
    <nb-badge
      class="large"
      position="top left"
      status="info"
      *ngIf="linkCount() > 0"
      [text]="linkCount()"></nb-badge>
    <nb-icon pack="fas" icon="link"></nb-icon>
  </button>
</div>
